"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var hooks_1 = require("../../hooks");
var utils_1 = require("../../utils");
var useStoreContext_1 = require("./useStoreContext");
/**
 *
 * @param mappedStoreCallback
 * @param equalityCheck
 */
var useMappedStoreState = function (mappedStoreCallback, equalityCheck) {
    if (equalityCheck === void 0) { equalityCheck = utils_1.shallowEqual; }
    var store = useStoreContext_1.default().store;
    var forceUpdate = hooks_1.useForceUpdate().forceUpdate;
    var result = mappedStoreCallback(store.get);
    // Rather than sub/unsub from the store endlessly if the user
    // passes a lambda as the store callback or equality check,
    // we use refs to hold the values
    var lastResultRef = React.useRef(result);
    var mappedStoreCallbackRef = React.useRef(mappedStoreCallback);
    var equalityCheckRef = React.useRef(equalityCheck);
    // We use layoutEffect instead of the normal effect in order to prevent
    // additional renders if multiple useMappedStoreState are used.
    React.useLayoutEffect(function () {
        lastResultRef.current = result;
        mappedStoreCallbackRef.current = mappedStoreCallback;
        equalityCheckRef.current = equalityCheck;
    }, [result, mappedStoreCallback, equalityCheck]);
    React.useLayoutEffect(function () {
        var unsubscribed = false;
        var callback = function () {
            if (!unsubscribed) {
                if (!equalityCheckRef.current(lastResultRef.current, mappedStoreCallbackRef.current(store.get))) {
                    forceUpdate();
                }
            }
        };
        // it's possible there's been a state change between the initial render and the
        // subscription we're about to make
        callback();
        var unsubscribe = store.subscribe(callback);
        return function () {
            unsubscribed = true;
            unsubscribe();
        };
    }, [store]);
    return result;
};
exports.default = useMappedStoreState;
//# sourceMappingURL=useMappedStoreState.js.map